import React, { Component, Fragment } from 'react';
import './FilterMenu.Module.scss';
import {connect} from 'react-redux';
import { history } from 'components/App/components/UnauthenticatedApp';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBolt, faChevronLeft, faCode, faHeart, faUsers, faUser, faClock, faSignOut, faFilter } from '@fortawesome/pro-solid-svg-icons';

import {faHeart as faHeartRegular} from '@fortawesome/pro-regular-svg-icons';

import Button       from 'components/UI/PageComponents/Button/Button';


import Slider, { Range } from 'rc-slider';
// We can just import Slider or Range to reduce bundle size
// import Slider from 'rc-slider/lib/Slider';
// import Range from 'rc-slider/lib/Range';
import 'rc-slider/assets/index.css';
import Tooltip from 'rc-tooltip';

import 'rc-tooltip/assets/bootstrap.css';

import {
    filterLevelChange,
    filterTypeChange,
    filterNameChange,
    filterMinTimeChange,
    filterMaxTimeChange,
    filterSortChange,
    
} from 'actions/filter';

const mapStateToProps = (state, props) => {
    return {
        filter: state.filter,

        authentication: state.authentication,
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    filterLevelChange,
    filterTypeChange,
    filterNameChange,
    filterMinTimeChange,
    filterMaxTimeChange,
    filterSortChange,
};


class FilterMenu extends Component {

    constructor() {
        super();

        this.handleLevelChange = this.handleLevelChange.bind((this));
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSliderChange = this.handleSliderChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleSortChange   = this.handleSortChange.bind(this);
        this.shareFilterLink  = this.shareFilterLink.bind(this);

        this.state = {
            minTime: 5,
            maxTime: 150
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.filter.minTime != prevState.minTime || this.props.filter.maxTime != prevState.maxTime)  {
            this.setState({
                minTime: this.props.filter.minTime,
                maxTime: this.props.filter.maxTime
            })
        }
    }

    handleLevelChange(level) {
        let newLevels = this.props.filter.levels;

        if(this.props.filter.levels.includes(level)) {
            var index = newLevels.indexOf(level);
            if (index > -1) {
                newLevels.splice(index, 1);
            }
        } else {
            newLevels.push(level);
        }

        this.props.filterLevelChange(newLevels);
    }

    handleNameChange(event) {
        this.props.filterNameChange(event.target.value);
    }

    handleSortChange(event) {
        console.log('eventtargetvalue', event.target.value);
        this.props.filterSortChange(event.target.value);
    }

    handleSliderChange(times) {

        if(times[0] != this.props.filter.minTime) {
            this.props.filterMinTimeChange(times[0]);
        }

        if(times[1] != this.props.filter.maxTime) {
            this.props.filterMaxTimeChange(times[1]);
        }
    }

    handleTypeChange(event) {
        let typeName = event.target.name

        let newTypes = this.props.filter.types;

        if(this.props.filter.types.includes(typeName)) {
            var index = newTypes.indexOf(typeName);
            if (index > -1) {
                newTypes.splice(index, 1);
            }
        } else {
            newTypes.push(typeName);
        }

        this.props.filterTypeChange(newTypes);
    }

    shareFilterLink() {
        let filters = {
            ...this.props.filter
        };
        delete filters._persist;
        console.log(filters);
        let string = JSON.stringify(filters);
        string = encodeURIComponent(string);

        history.push(`/platform-filter/${string}`);
    }
    
    render() {
        const createSliderWithTooltip = Slider.createSliderWithTooltip;
        const Range = createSliderWithTooltip(Slider.Range);
        const Handle = Slider.Handle;
        

        const handle = (props) => {
            const { value, dragging, index, ...restProps } = props;
            return (
              <Tooltip
                prefixCls="rc-slider-tooltip"
                overlay={value}
                visible={dragging}
                placement="top"
                key={index}
              >
                <Handle value={value} {...restProps} />
              </Tooltip>
            );
          };

        return (
        <Fragment>
            
            <div styleName='filter-menu-wrapper'>

                {
                    this.props.display == 'false' ?
                    null
                    :
                    <Fragment>

                <h2><FontAwesomeIcon icon={faFilter}/> LESMATERIAAL</h2>
                <p>Middels het filter kun je specifiek
                de lessen naar voren halen die
                voor jou interessant zijn.</p>
                
                <input styleName='input' type="text" placeholder="Zoek" value={this.props.filter.name} onChange={this.handleNameChange}></input>
                <h3>SORTEER OP</h3>
                <select name="cars" onChange={this.handleSortChange}>
                    <option value="level" >Level</option>
                    <option value="date" >Nieuw - Oud</option>
                    <option value="code-techniek">Code &#x26; techniek</option>
                    <option value="art">kunst &#x26; creativiteit</option>
                    <option value="thinking">Kritisch denken</option>
                    <option value="duration">Duur</option>
                </select>
                <h3>MOEILIJKHEIDSGRAAD</h3>
                <label styleName='container' >
                    <CustomCheckbox
                        name='Intro'
                        subtitle='Kunst &amp; computational thinking.'
                        value={'Intro'}
                        checked={this.props.filter.levels.includes('Intro')}
                        handleChange={this.handleLevelChange}
                    />
                </label>
                <label styleName='container' >
                    <CustomCheckbox
                        name='Basis'
                        subtitle='Programmeren met blokken'
                        value={'Basis'}
                        checked={this.props.filter.levels.includes('Basis')}
                        handleChange={this.handleLevelChange}
                    />
                </label>
                <label styleName='container'>
                    <CustomCheckbox
                        name='Gevorderd'
                        subtitle='Van instructie naar interactie.'
                        value={'Gevorderd'}
                        checked={this.props.filter.levels.includes('Gevorderd')}
                        handleChange={this.handleLevelChange}
                    />
                </label>
                <label styleName='container'>
                    <CustomCheckbox
                        name='Expert'
                        subtitle='Kritische reflectie en code creatie'
                        value={'Expert'}
                        checked={this.props.filter.levels.includes('Expert')}
                        handleChange={this.handleLevelChange}
                    />
                </label>
                


                <h3>SOORT</h3>
                
                <label styleName={`container icon-container`}>
                    <input checked={this.props.filter.types.includes('plugged')} name='plugged' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='icon-bolt-checkmark'></span>
                    <p>Plugged</p>
                </label>
                <label styleName={`container icon-container`}>
                    <input checked={this.props.filter.types.includes('unplugged')} name='unplugged' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='icon-checkmark'></span>
                    <p>Unplugged</p>
                </label>
                <label styleName={`container icon-container`}>
                    <input checked={this.props.filter.types.includes('group')} name='group' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='icon-users-checkmark'></span>
                    <p>Klassikaal</p>
                </label>
                <label styleName={`container icon-container`}>
                    <input checked={this.props.filter.types.includes('individual')} name='individual' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='icon-user-checkmark'></span>
                    <p>Zelfstandig</p>
                </label>
                <label styleName='container'>
                    <input checked={this.props.filter.types.includes('po')} name='po' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='checkmark'></span>
                    <p>PO</p>
                </label>
                <label styleName='container'>
                    <input checked={this.props.filter.types.includes('vo')} name='vo' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='checkmark'></span>
                    <p>VO</p>
                </label>
                <label styleName='container'>
                    <input checked={this.props.filter.types.includes('les')} name='les' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='checkmark'></span>
                    <p>Les</p>
                </label>
                <label styleName='container'>
                    <input checked={this.props.filter.types.includes('workshop')} name='workshop' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='checkmark'></span>
                    <p>Workshop</p>
                </label>
                <label styleName='container'>
                    <input checked={this.props.filter.types.includes('kunstwerk')} name='kunstwerk' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='checkmark'></span>
                    <p>Kunstwerk</p>
                </label>
                <label styleName='container'>
                    <input checked={this.props.filter.types.includes('event')} name='event' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                    <span styleName='checkmark'></span>
                    <p>Event</p>
                </label>
                { this.props.authentication.isLoggedIn &&
                    <label styleName='container'>
                        <input checked={this.props.filter.types.includes('favorieten')} name='favorieten' onChange={this.handleTypeChange} styleName='checkbox' type="checkbox" />
                        <span styleName='checkmark'></span>
                        <p>Favorieten</p>
                    </label>
                }
                <div styleName='slider-label'>
                    <p>5 min</p>
                    <p>150 min</p>
                </div>
                <div style={{width:'100%'}}>
                    <Range onAfterChange={this.handleSliderChange} min={5} max={150} defaultValue={[this.state.minTime, this.state.maxTime]} handle={handle}  tipFormatter={value => `${value}`}/>
                </div>
                {/* <h3>Tech specs</h3>
                <select name="cars">
                    <option value="volvo" >Scratch</option>
                    <option value="saab">Makkelijk</option>
                    <option value="fiat">Gemiddeld</option>
                    <option value="audi">Moeilijk</option>
                </select> */}

                <Button
                    item={{
                        text: "Filterlink genereren",
                        href: "#",
                        button_color: "#ff3956",
                        link_type: ""
                    }}
                    noBorder={true}
                    onClick={this.shareFilterLink}
                />
            
                </Fragment>
            }
            </div>
            
        </Fragment>
        );
    }
}

class CustomCheckbox extends Component {

    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        this.props.handleChange(this.props.value);
    }

    render() {
        return (
            <Fragment>
            <input styleName={this.props.name} onChange={this.handleChange} checked={this.props.checked} type="checkbox" />
            <span styleName='checkmark margin-top'></span>
            <p>{this.props.name}</p>
            <p styleName='itallic'><i>{this.props.subtitle}</i></p>
            </Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterMenu);
